import type { Definition } from '~/types'
import imageSizes from '../../constants/imageSizes'

const BlockIndexChapter: Definition = {
  contentType: 'BlockIndexChapter',
  fields: [
    {
      id: 'Title',
      name: 'Title',
      type: 'Symbol'
    },
    {
      id: 'navigationTitle',
      name: 'Navigation Title',
      type: 'Symbol'
    },
    {
      id: 'description',
      name: 'Highlight Description',
      type: 'Text'
    },
    {
      id: 'coverImage',
      name: 'Cover Image (image for highlight)',
      type: 'ModuleMedia',
      imageOptions: { sizes: imageSizes.columns6_11 }
    },
    {
      id: 'contentGroups',
      name: 'Content Groups',
      type: 'Array',
      subType: 'BlockIndexContentGroup',
      validations: [{ size: { min: 0, max: 8 } }]
    }
  ]
}

const BlockIndexContentGroup: Definition = {
  contentType: 'BlockIndexContentGroup',
  fields: [
    {
      id: 'contentBlocks',
      name: 'Content Blocks',
      type: 'Array',
      subType: [
        'ModuleMedia',
        'BlockMetrics',
        'BlockContent',
        'BlockSimpleQuote',
        'ModuleVideo',
        'ModuleInternalVideo',
        'BlockIndexHighlight'
      ],
      validations: [{ size: { min: 0, max: 8 } }]
    }
  ]
}

const BlockIndexHighlight: Definition = {
  contentType: 'BlockIndexHighlight',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol'
    },
    {
      id: 'text',
      name: 'Text',
      type: 'RichText'
    },
    {
      id: 'isFullScreen',
      name: 'Display Full screen',
      type: 'Boolean'
    },
    {
      id: 'link',
      name: 'Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'theme',
      name: 'Theme',
      type: 'GlobalDataTheme'
    }
  ]
}

const PageIndex: Definition = {
  contentType: 'PageIndex',
  fields: [
    {
      id: 'reports',
      name: 'Our Reports',
      type: 'BlockReportsList',
      imageOptions: { sizes: imageSizes.index_list }
    },
    {
      id: 'quote',
      name: 'Quote',
      type: 'BlockSimpleQuote'
    },
    {
      id: 'image',
      name: 'Image',
      type: 'ModuleMedia',
      imageOptions: { sizes: imageSizes.columns6_11 }
    },
    {
      id: 'heroEyebrow',
      name: 'Eyebrow',
      type: 'Text',
      localized: true
    }
  ]
}

const PageIndexIndustryGated: Definition = {
  contentType: 'PageIndexIndustryGated',
  fields: [
    {
      id: 'backLink',
      name: 'Back Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'intro',
      name: 'Intro',
      type: 'BlockTextMetrics'
    },
    {
      id: 'image',
      name: 'Image',
      type: 'ModuleMedia',
      imageOptions: { sizes: imageSizes.columns10_21 }
    },
    {
      id: 'contentBlock1',
      name: 'Content Block 1',
      type: 'BlockContent'
    },
    {
      id: 'metricsBlock',
      name: 'Metrics Block',
      type: 'BlockMetrics'
    },
    {
      id: 'form',
      name: 'Form',
      type: 'BlockForm'
    },
    {
      id: 'heroEyebrow',
      name: 'Eyebrow',
      type: 'Text',
      localized: true
    }
  ]
}

const PageIndexIndustryUngated: Definition = {
  contentType: 'PageIndexIndustryUngated',
  fields: [
    {
      id: 'backLink',
      name: 'Back Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'heroImage',
      name: 'Hero Image',
      type: 'ModuleMedia',
      imageOptions: { sizes: imageSizes.columns4_34 }
    },
    {
      id: 'intro',
      name: 'Intro',
      type: 'BlockTextMetrics'
    },
    {
      id: 'contentBlock1',
      name: 'Content Block 1',
      type: 'BlockContent'
    },
    {
      id: 'metricsBlock',
      name: 'Metrics Block',
      type: 'BlockMetrics'
    },
    {
      id: 'reports',
      name: 'Sub Industry Reports',
      type: 'BlockReportsList'
    },
    {
      id: 'blockIndexChapter',
      name: 'Content Groups',
      type: 'Array',
      subType: 'BlockIndexChapter',
      validations: [{ size: { min: 0, max: 8 } }],
      lazy: true
    },
    {
      id: 'callToAction',
      name: 'Call to action',
      type: 'BlockCallToAction'
    },
    {
      id: 'heroEyebrow',
      name: 'Eyebrow',
      type: 'Text',
      localized: true
    },
    {
      id: 'navigationButton',
      name: 'Navigation Button',
      type: ['ModuleMedia', 'ModuleNavigationLink'],
      localized: true
    },
    {
      id: 'form',
      name: 'Form (experiment)',
      type: 'BlockForm'
    }
  ]
}

const PageIndexSubIndustry: Definition = {
  contentType: 'PageIndexSubIndustry',
  fields: [
    {
      id: 'parent',
      name: 'Index Industry parent page',
      type: 'PageIndexIndustryGated'
      // required: true
    },
    {
      id: 'backLink',
      name: 'Back Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'media',
      name: 'Media Image or Video',
      type: ['ModuleMedia', 'ModuleVideo', 'ModuleInternalVideo']
      // @TODO define image sizes: 16:9 - 12 cols
      // imageOptions: { sizes: imageSizes.columns3_34 }
    },
    {
      id: 'intro',
      name: 'Intro',
      type: 'Text'
    },
    {
      id: 'blockIndexChapter',
      name: 'Content Groups',
      type: 'Array',
      subType: 'BlockIndexChapter',
      validations: [{ size: { min: 0, max: 8 } }],
      lazy: true
    },
    {
      id: 'logobar',
      name: 'Logo bar',
      type: 'BlockLogoBar'
    },
    {
      id: 'callToAction',
      name: 'Call to action',
      type: 'BlockCallToAction'
    },
    {
      id: 'heroEyebrow',
      name: 'Eyebrow',
      type: 'Text',
      localized: true
    },
    {
      id: 'form',
      name: 'Form (experiment)',
      type: 'BlockForm'
    }
  ]
}

const PageIndexPrevious: Definition = {
  contentType: 'PageIndexPrevious',
  fields: [
    {
      id: 'linksList',
      name: 'Links List',
      type: 'Array',
      subType: 'BlockLinksList',
      validations: [{ size: { min: 1, max: 20 } }]
    },
    {
      id: 'backLink',
      name: 'Back Link',
      type: 'ModuleNavigationLink'
    }
  ]
}

const PageIndex2025: Definition = {
  contentType: 'PageIndex2025',
  fields: [
    {
      id: 'backLink',
      name: 'Back Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'heroTitle',
      name: 'Hero Title',
      type: 'Symbol'
    },
    {
      id: 'introduction',
      name: 'Introduction',
      type: 'BlockTextMetrics'
    },
    {
      id: 'mobileOnlyStory',
      name: 'Mobile Only Story',
      type: 'Array',
      subType: ['BlockStory'],
      validations: [{ size: { min: 0, max: 1 } }]
    },
    {
      id: 'stories',
      name: 'Block Stories Collection',
      type: 'Array',
      subType: ['BlockStory'],
      localized: true
    },
    {
      id: 'subIndustryCollectionTitle',
      name: 'Sub Industry Collection Title',
      type: 'Symbol'
    },
    {
      id: 'subIndustryCollectionDescription',
      name: 'Sub Industry Collection Description',
      type: 'Symbol'
    },
    {
      id: 'subIndustryCollection',
      name: 'Sub Industry Collection',
      type: 'Array',
      subType: ['PageIndexChapter2025'],
      localized: true
    },
    {
      id: 'chapterCollectionTitle',
      name: 'Chapter Collection Title',
      type: 'Symbol'
    },
    {
      id: 'chapterCollection',
      name: 'Chapter Collection',
      type: 'Array',
      subType: ['PageIndexChapter2025'],
      imageOptions: {
        lazy: true
      },
      localized: true
    },
    {
      id: 'callToAction',
      name: 'Call to Action',
      type: 'ModuleMediaCard',
      localized: true
    },
    {
      id: 'form',
      name: 'Form',
      type: 'BlockForm'
    },
    {
      id: 'methodologyTitle',
      name: 'Methodology Title',
      type: 'Symbol'
    },
    {
      id: 'methodologyDescription',
      name: 'Methodology Description',
      type: 'RichText'
    },
    {
      id: 'notificationBar',
      name: 'Notification Bar',
      type: 'BlockNotificationBar'
    }
  ]
}

const PageIndexChapter2025: Definition = {
  contentType: 'PageIndexChapter2025',
  fields: [
    {
      id: 'parent',
      name: 'Index 2025 parent page',
      type: 'PageIndex2025'
      // required: true
    },
    {
      id: 'hero',
      name: 'Hero',
      type: 'BlockContent',
      imageOptions: { sizes: imageSizes.columns5_11 }
    },
    {
      id: 'bentoCardTitle',
      name: 'Bento Card Title (USE IF ITS A PERCENTAGE!)',
      type: 'Symbol'
    },
    {
      id: 'bentoCardDescription',
      name: 'Bento Card Description (USE IF ITS A PERCENTAGE!)',
      type: 'Symbol'
    },
    {
      id: 'introduction',
      name: 'Introduction',
      type: 'RichText',
      localized: true
    },
    {
      id: 'callToActionIntro',
      name: 'Call to Action (Next to Introduction)',
      type: 'ModuleMediaCard',
      localized: true
    },
    {
      id: 'downloadPdf',
      name: 'Download PDF Button',
      type: 'ModuleMedia'
    },
    {
      id: 'blockIndexChapter',
      name: 'Chapter Group',
      type: 'Array',
      subType: 'BlockIndexChapter',
      validations: [{ size: { min: 0, max: 5 } }],
      lazy: true
    },
    {
      id: 'callToActionMobile',
      name: 'Call to Action (Mobile Only)',
      type: 'ModuleMediaCard',
      localized: true
    },
    {
      id: 'chapterTitlePrevious',
      name: 'Chapter Title Previous',
      type: 'Symbol'
    },
    {
      id: 'chapterTitleNext',
      name: 'Chapter Title Next',
      type: 'Symbol'
    },
    {
      id: 'relatedChapters',
      name: 'Related Chapters',
      type: 'Array',
      subType: 'PageIndexChapter2025',
      validations: [{ size: { min: 0, max: 2 } }]
    },
    {
      id: 'seeAllChaptersLik',
      name: 'See All Chapters Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'form',
      name: 'Form',
      type: 'BlockForm'
    },
    {
      id: 'video',
      name: 'Video',
      type: ['ModuleVideo', 'ModuleInternalVideo'],
      imageOptions: { sizes: imageSizes.columns12_21 }
    }
  ]
}

const BlockLinksList: Definition = {
  contentType: 'BlockLinksList',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      // required: true,
      localized: true
    },
    {
      id: 'links',
      name: 'Links',
      type: 'Array',
      subType: 'ModuleNavigationLink',
      validations: [{ size: { min: 1, max: 20 } }],
      // required: true,
      localized: true
    }
  ]
}

const BlockStory: Definition = {
  contentType: 'BlockStory',
  fields: [
    {
      id: 'subtitle',
      name: 'Subtitle',
      type: 'Symbol',
      localized: true
    },
    {
      id: 'title',
      name: 'title',
      type: 'Symbol',
      localized: true
    },
    {
      id: 'author',
      name: 'Author Name',
      type: 'Symbol'
    },
    {
      id: 'authorInfo',
      name: 'Author Additional Information',
      type: 'Symbol'
    },
    {
      id: 'media',
      name: 'Media Image or Video',
      type: ['ModuleMedia', 'ModuleVideo', 'ModuleInternalVideo']
    },
    {
      id: 'theme',
      name: 'Theme',
      type: 'GlobalDataTheme'
    },
    {
      id: 'link',
      name: 'Link',
      type: 'ModuleNavigationLink'
    }
  ]
}

export default {
  BlockIndexChapter,
  BlockIndexContentGroup,
  BlockIndexHighlight,
  BlockLinksList,
  BlockStory,

  PageIndex,
  PageIndexIndustryGated,
  PageIndexIndustryUngated,
  PageIndexSubIndustry,
  PageIndexPrevious,
  PageIndex2025,
  PageIndexChapter2025
}
